import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand, $getSelection, $isRangeSelection } from 'lexical';
import { $createInsertMentionNode, InsertMentionNode } from '../nodes/InsertMentionNode';

export const INSERT_MENTION_COMMAND: LexicalCommand<{ id: number, name: string }> = createCommand();

export const InsertMentionPlugin: FC = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!editor.hasNodes([InsertMentionNode])) {
            throw new Error('InsertMentionPlugin: InsertMentionNode not registered on editor');
        }

        editor.registerCommand(
            INSERT_MENTION_COMMAND,
            (payload: { id: number, name: string }) => {
                const insertMentionNode = $createInsertMentionNode(payload.id, payload.name);
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) {
                    return false
                }
                selection?.insertNodes([insertMentionNode]);
                selection?.insertText(" ");
                return true;
            },
            COMMAND_PRIORITY_EDITOR
        )
    }, [editor]);

    return null;
};

export default InsertMentionPlugin;